import React from 'react';
import { useController, Control, FieldValues, Path } from 'react-hook-form';

interface RHFInputNumberProps<T extends FieldValues> {
  name: Path<T>;
  control: Control<T>;
  label: string;
  required?: boolean;
  disabled?: boolean;
  min?: number;
  max?: number;
  step?: string;
  placeholder?: string;
  suffix?: string;
  className?: string;
}

export function RHFInputNumber<T extends FieldValues>({
  name, control, label, required, disabled, min, max, step, placeholder, suffix, className
}: RHFInputNumberProps<T>) {
  const { field, fieldState } = useController({ name, control });

  return (
    <div className={`fv-row mb-5 ${className || ''}`}>
      <label className={`form-label ${required ? 'required' : ''}`}>{label}</label>
      <div className={suffix ? 'input-group' : ''}>
        <input
          className={`form-control ${fieldState.error ? 'is-invalid' : ''}`}
          type="number"
          autoComplete="off"
          placeholder={placeholder}
          disabled={disabled}
          min={min}
          max={max}
          step={step}
          value={field.value ?? ''}
          onChange={field.onChange}
          onBlur={field.onBlur}
          ref={field.ref}
        />
        {suffix && <span className="input-group-text">{suffix}</span>}
      </div>
      {fieldState.error && (
        <div className="fv-plugins-message-container invalid-feedback">
          {fieldState.error.message}
        </div>
      )}
    </div>
  );
}
